// extracted by mini-css-extract-plugin
export default {"link":"MenuLink-module--link--243ab","active":"MenuLink-module--active--46533","icon":"MenuLink-module--icon--4b686"};